import { Dropdown, DropdownProps } from 'antd';
import classnames from 'classnames';
import styles from './HeaderDropdown.module.less';

type DropdownType = DropdownProps & {
  storeStatus?: boolean;
};

export const HeaderDropdown = ({ children, storeStatus = false, ...reset }: DropdownType) => {
  const cls = classnames({
    [styles.dropdownCustomize]: true,
    [styles.storeDropdownCustomize]: storeStatus,
  });
  return (
    <div style={{ margin: '0', height: '100%' }}>
      <Dropdown
        getPopupContainer={(triggerNode) => triggerNode.parentElement as HTMLElement}
        {...reset}
        overlayClassName={cls}
      >
        <div className={styles.buttonHover}>{children}</div>
      </Dropdown>
    </div>
  );
};
